var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-document-24-outlined"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 56.6667C53.7045 56.6667 60.2112 60.5317 60.2083 67.2932L53.125 67.2901C53.1258 65.4266 50.3033 63.75 42.5 63.75C34.6967 63.75 31.8742 65.4266 31.875 67.2902L24.7916 67.2932C24.7888 60.5317 31.2954 56.6667 42.5 56.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.125 42.5C53.125 36.632 48.368 31.875 42.5 31.875C36.632 31.875 31.875 36.632 31.875 42.5C31.875 48.368 36.632 53.125 42.5 53.125C48.368 53.125 53.125 48.368 53.125 42.5ZM42.5 38.9583C40.544 38.9583 38.9583 40.544 38.9583 42.5C38.9583 44.456 40.544 46.0417 42.5 46.0417C44.456 46.0417 46.0417 44.456 46.0417 42.5C46.0417 40.544 44.456 38.9583 42.5 38.9583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2917 11.7786C67.2917 11.1205 67.1999 10.4655 67.0191 9.8327C65.9444 6.0712 62.0239 3.89313 58.2624 4.96784L15.7624 17.1107C12.7215 17.9795 10.625 20.7589 10.625 23.9215V74.375C10.625 78.287 13.7963 81.4583 17.7083 81.4583H67.2917C71.2037 81.4583 74.375 78.287 74.375 74.375V24.7917C74.375 20.8797 71.2037 17.7083 67.2917 17.7083V11.7786ZM17.7083 24.7917H67.2917V74.375H17.7083V24.7917ZM39.4613 17.7056L60.2083 11.7786V17.7056H39.4613Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.a3bb0a24911aac6eb9cce11d2bb0cd3a.svg";
export { ForwardRef as ReactComponent };